<template>
<!-- 应用范围  -->
<!-- FBA货件、成本中心、发货单、交货单、采购变更单、采购计划、装配单、成本补录、采购入库单、出入库记录、调拨单、发货计划 -->
  <vxe-grid
    ref="xTable"
    v-on="$listeners"
    v-bind="$attrs"
    v-loading="loading"
    class="gj-expand-table gj-lrz-table"
    :columns="tableColumn"
    height="auto"
    border="inner"
    auto-resize
    row-id="rowId"
    :loading="false"
    :scroll-y="{mode: 'wheel',oSize:20}"
    :sort-config="{trigger: 'cell', defaultSort: handleDefaultSort, remote: true}"
    :row-class-name="handleRowClassName"
    :span-method="handleMerge"
    @checkbox-all="selectionChangeAll"
    :data="tableData">
    <!-- 自定义复选框 -->
    <template #check="{row, checked, indeterminate}">
      <span v-if="row.isParent && !row.isExpandRow" class="item-checkbox" @click.stop="handleChangeCheck(row)">
        <i :class="[checked && 'is-checked',indeterminate && 'is-indeterminate']"></i>
      </span>
    </template>
    <!-- 传递插槽  -->
    <template v-for="item in slotArr"
      v-slot:[item]="props">
      <slot :name="item"
        v-bind="props" />
    </template>
    <!-- 无数据页面展示 -->
    <template #empty>
      <gj-empty text="暂无数据"></gj-empty>
    </template>
    <!-- 分页器 -->
    <template #pager>
      <div v-show="pagerConfig.total>0" class="gj-table-pagination">
        <el-pagination @size-change="pageChange"
          @current-change="pageChange('page')"
          :current-page.sync="pagerConfig.currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="pagerConfig.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagerConfig.total"
          background
          :pager-count="5">
        </el-pagination>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import { CACHE_PAGINATION_PAGESIZE } from '@/utils/const'
import _ from 'lodash'
export default {
  props: {
    /** 表格数据 */
    list: {
      type: Array,
      default: () => [],
      require: true
    },
    /**
     * 配置动态列的数组  配置文档查看官方文档
     * @see {@link https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api columns}
     */
    columns:{
      type:Array,
      default:()=>[],
      require:true
    },
    /** 页面加载的loading */
    loading: {
      type: Boolean,
      default: false
    },
    /** 分页器相关配置 */
    pagerConfig: {
      type: Object,
      require: true,
      default: () => {
        return {
          currentPage: 1,
          pageSize: 20,
          total: 0
        }
      }
    },
    /** 分页数组配置 */
    pageSizes: {
      type: Array,
      default: () => {
        return [20, 50, 100, 200, 500]
      }
    },
    /** 排序配置 */
    defaultSort: {
      type: Object,
      default: null
    },
    /** 是否勾选  */
    selection:{
      type:Boolean,
      default:false
    },
    /** 展开配置  */
    expandConfig:{
      type: Object,
      default: null,
      require: true,
    },
    /** 是否需要转 */
    isFormat:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      tableData: [],
      tableColumn:[], // 动态列的配置数据
      slotArr:[],     // 注册插槽 传递插槽,
    }
  },
  watch: {
    list: {
      handler (newVal, oldVal) {
        this.handleData(newVal)
      },
      immediate: true
    },
    columns : {
      handler(newVal,oldVal){
        this.handleColumns(_.cloneDeep(newVal))
        this.handleSlots(newVal)
      },
      immediate:true
    },
  },
  methods: {
    /** 监听数据 添加数据标识 */
    handleData (data) {
      let list = []
      data.forEach((v, i) => {
        // 标记显示父元素
        v.isParent = true
        let child = v[this.expandConfig.children] || []
        list.push(v)
        child.map((cv, ci) => {
          cv.parentIndex = i
          cv.index = ci
          cv.isChild = true
        })
        child = child.filter(v=>!v.isExpandRow)
        // 追加一个扩展项
        if(v.itemCopy.length>3){
          child.push({ isExpandRow: true, ...v })
        }
        list = list.concat(child)
      })
      list.map((v, i) => {
        v.rowId = `rId_${i + 30}`;
        return v;
      });
      this.tableData = list
    },
     /**
     * 遍历出 需要在vxe-grid注册的插槽  传递插槽
     * @param { arrry } columns -表格列的配置的数据
     * @returns {Arrry} 返回插槽数据列表
     */
    handleSlots(columns){
      const slots = columns.filter(v=>v.slots).map(v=>v.slots)
      this.slotArr = [...slots.map(v=>v.default).filter(v=>v),...slots.map(v=>v.header).filter(v=>v)]
    },
    /** 对column做的一些判断 */
    handleColumns(columns){
      // 原有脏columns 进行格式化处理
      if(this.isFormat){
        this.formatColumns(columns)
      }
      // console.log(columns)
      // 追加复选框
      if(this.selection){
        columns.unshift({
          id: 'checkbox',
          field: 'checkbox',
          fixed:'left',
          align:'center',
          type:'checkbox',
          width: '50px',
          slots: { checkbox:'check'} ,
        })
      }
      this.tableColumn = columns
    },
    /** 格式化columns 数据 */
    formatColumns(columns){
      columns.map(v=>{
        v.title = v.header
        if(v.field.includes('slot')){
          v.slots = {
            default: v.field.split('slot:')[1]
          }
          v.field = v.field.split('slot:')[1]
        }
        return v
      })
    },
    /**合并 */
    handleMerge ({ row, _columnIndex }) {
      // 先判断扩展项
      if (row.isExpandRow) {
        if (_columnIndex === 1) {
          return { rowspan: 1, colspan: this.tableColumn.length - 1}
        } else if (_columnIndex > 1) {
          return { rowspan: 0, colspan: 0 }
        }
      }
      // 判断父子表格的合并项
      if (row.isParent) {
        const span = this.expandConfig.span
        if (_columnIndex === span[0]) {
          return { rowspan: 1, colspan: span[1] }
        } else if (_columnIndex > span[0] && _columnIndex < (span[1]+1)) {
          return { rowspan: 0, colspan: 0 }
        }
      }
    },
    /** 分页 */
    pageChange (page) {
      this.$cache.setCache(CACHE_PAGINATION_PAGESIZE.call(this), { pageSize: this.pagerConfig.pageSize })
      this.$emit('page-change', page)
      this.$emit('selection-change', []);
    },
    /**
     * 处理排序
     */
    handleDefaultSort () {
      if (this.defaultSort) {
        return {
          field: this.defaultSort.prop,
          order: (this.defaultSort.order || 'descending').replace('ending', '')
        }
      }
      return null
    },
    /* 追加class */
    handleRowClassName ({ row, rowIndex, $rowIndex }) {
      if (row.isExpandRow) {
        return 'gj-table-expend-row'
      }
      if (row.isParent) {
        return 'gj-table-parent-row'
      }
    },
    /** 监听全选 */
    selectionChangeAll(obj) {
      this.$emit('selection-change', obj.records.filter(v=>v.isParent));
    },
    /**每一项复选时 */
    handleChangeCheck(row){
      this.$refs.xTable.toggleCheckboxRow(row).then(ref=>{
        const records = ref.getCheckboxRecords()
        if(records.length === this.pagerConfig.pageSize){
          ref.toggleAllCheckboxRow()
        }
        this.$emit('selection-change', records);
      })
    }
  }
}
</script>

<style lang="scss">
.gj-expand-table {
  height: 100%;
  // 勾选项的样式
  .vxe-checkbox--icon::before{
    border-width: 1px !important;
  }
  .item-checkbox {
    i{
      display: inline-block;
      position: relative;
      border: 1px solid #D8DADD;
      border-radius: 2px;
      box-sizing: border-box;
      width: 14px;
      height: 14px;
      background-color: #fff;
      z-index: 1;
      transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
    }
    i::after{
      box-sizing: content-box;
      content: "";
      border: 1px solid #fff;
      border-left: 0;
      border-top: 0;
      height: 7px;
      left: 4px;
      position: absolute;
      top: 1px;
      transform: rotate(45deg) scaleY(0);
      width: 3px;
      transition: transform .15s ease-in .05s;
      transform-origin: center;
    }
    i.is-checked{
      background-color: #1f6eef;
      border-color: #1f6eef;
    }
    i.is-checked::after{
      transform: rotate(45deg) scaleY(1);
    }
    i:hover{
      border-color: #1f6eef;
    }
  }
  .gj-table-expend-row {
    height: 40px;
    line-height: 40px;
    background-color: #fff !important;
    td:not(.vxe-footer--column) {
      .expend-row {
        padding: 4px 0;
        text-align: center;
      }
    }
  }
 .gj-table-parent-row, tr.gj-table-parent-row:hover > td {
    background-color: #f6f7f8!important;
  }
 .vxe-table--render-default .vxe-header--column.col--ellipsis:not(.col--actived) > .vxe-cell, .vxe-table--render-default .vxe-body--column.col--ellipsis:not(.col--actived) > .vxe-cell, .vxe-table--render-default .vxe-footer--column.col--ellipsis:not(.col--actived) > .vxe-cell, .vxe-checkbox .vxe-checkbox--label, .vxe-radio .vxe-radio--label, .vxe-radio-button .vxe-radio--label{
    overflow: unset;
    white-space: unset;
    text-overflow: unset;
  }
}
</style>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
  /deep/ .col--last{
    .vxe-cell{
      padding-left: 16px;
    }
  }
  /deep/ .vxe-table--footer-wrapper{
    color: #333;
  }
  /deep/.gj-help--icon{
    .gj-icon{
      font-size: 13px;
      color: #666;
    }
  }
  /deep/ .vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
  ::v-deep .vxe-table  .vxe-header--row {
    height: 40px !important;
    background: $gj-tableHeader-color;
  }
  ::v-deep .vxe-table  .vxe-footer--row{
    background: $gj-tableHeader-color;
  }
  /deep/ .col--right{
    .vxe-cell{
      justify-content: flex-end;
    }
  }

  /deep/ .vxe-table--render-default .vxe-table--fixed-left-wrapper.scrolling--middle {
    box-shadow: 4px 0px 6px -2px rgba($color: #000000, $alpha: 0.12);
  }
  /deep/ .vxe-table--render-default .vxe-table--fixed-right-wrapper.scrolling--middle{
    box-shadow: -4px 0 6px -2px rgba($color: #000000, $alpha: 0.12);
  }
  /deep/ .vxe-table--footer{
    height: 40px;
  }
  /deep/ .vxe-table--render-default .vxe-table--footer-wrapper{
    background-color: #e8eaec;
  }
  /* 字体大小 */
  /deep/ .vxe-table.size--small {
    font-size: 12px;
  }
 .el-pagination{
    font-weight: normal;
 }
 /deep/ .vxe-table--render-default .vxe-body--row.row--hover {
   background-color: $gj-hover-color;
}
</style>
